import backend from '@common/backend';

export const groupFromBE = (group: any) =>
	group
		? {
				...group,
				service: group.service_id,
				service_template: group.service_template_id,
			}
		: group;

const BASE = '/teachers';
export interface IGetTeachersQuery {
	search?: string;
	page?: number;
	limit?: number;
}

export const getTeachers = async (query: IGetTeachersQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const getTeacherUnreviewedLessons = async (query: { service_id: number }) =>
	backend.get(`${BASE}/unreviewedLessons`, {
		params: query,
	});

export const createTeacher = async (data: any) => backend.post(`${BASE}`, data);

export const getTeacher = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeTeacher = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveTeacher = async (id: number, data: any) => backend.post(`${BASE}/${id}`, data);

export const getTeacherGroups = async (query: any) =>
	backend
		.get(`${BASE}/groups`, {
			params: query,
		})
		.then((groups: any) => groups.map(groupFromBE));
